<h1 bui-dialog-title>{{ 'adblock.detected.headline' | msgKey }}</h1>
<bui-dialog-content>
	{{ 'adblock.detected.text1' | msgKey }}
	<br> {{ 'adblock.detected.text2' | msgKey }}
	<br> {{ 'adblock.detected.text3' | msgKey }}
	<br> {{ 'hotline.fragen' | msgKey }}{{ 'hotline.telefon.secondlevel' | msgKey}}.
</bui-dialog-content>
<bui-dialog-actions>
	<button bas-button color="accent" bui-dialog-action>{{ 'button.ok.alt' | msgKey}}</button>
</bui-dialog-actions>